import {FC} from 'react'
import s from './style.module.css'
import {clsx} from 'clsx'
import {LanguageCodes} from '@app/i18n/settings'

export interface CardInfo {
  title: string
  subTitle: string
  css?: string
  titleCss?: string
  subTitleCss?: string
  lang: LanguageCodes
}

const BaseInfo: FC<CardInfo> = ({title, titleCss, css, lang}) => {
  const headCss = clsx(s.title, css, 'text-txt-primary', css, titleCss, {
    'h-24 py-5': lang !== 'en',
    'h-28 py-5': lang === 'te',
  })

  return (
    <div className={s.info_wrapper}>
      <p className={headCss}>{title}</p>
    </div>
  )
}

export default BaseInfo
